/* eslint-disable no-unneeded-ternary */
/* eslint-disable no-restricted-syntax */
import React, { useCallback, useEffect, useRef, useState } from 'react'
import { FormHandles } from '@unform/core'
import { Form } from '@unform/web'
import gql from 'graphql-tag'
import { toast } from 'react-toastify'
import { isBefore, format, addDays } from 'date-fns'
import { ptBR } from 'date-fns/locale'
import ExcelJS from 'exceljs'

import IProfessional from '@monorepo-zazuu/shared/interfaces/IProfessional'

import Button from '../../components/Button'
import InputRef from '../../components/InputRef'
import SelectRef from '../../components/SelectRef'
import { calculateSizeByWeigthPet } from '../../utils/calculateSize'
import convertToCurrencyFormat from '../../utils/convertToCurrencyFormat'
import TypePaymentEnum from '../../utils/enums/TypePaymentEnum'

import client from '../../services/api-graphql'

import * as Styles from './styles'

interface IDataReports {
  dateInitial: string
  dateFinal: string
  professionalId: string
}

interface IExcelDataProps {
  day: string
  tutor: string
  pet: string
  specie: string
  service: string
  petSize: string | undefined
  value: string | number
  additional: string
  additionalValue: string | number
  discount: string | number
  finalValue: string | number
  value80: string | number
  paymentStatus: string
  paymentMethod: string
}

const FinancialReports: React.FC = () => {
  const formRef = useRef<FormHandles>(null)

  const [loading, setLoading] = useState(false)
  const [professionals, setProfessionals] = useState<IProfessional[]>([])

  const exportToCSV = useCallback(
    (
      csvData: IExcelDataProps[],
      fileName,
      time,
      professionalName,
      totalRows,
      revenue,
      professionalRent,
      suppliesTotalValue,
      suppliesArray
    ) => {
      try {
        const workbook = new ExcelJS.Workbook()

        workbook.views = [
          {
            x: 0,
            y: 0,
            width: 10000,
            height: 20000,
            firstSheet: 0,
            activeTab: 1,
            visibility: 'visible'
          }
        ]

        const worksheet = workbook.addWorksheet('Relatório financeiro')

        // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
        //                           COLUMNS CONFIG
        // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

        worksheet.columns = [
          { header: 'Dia', key: 'day', width: 20 },
          { header: 'Tutor', key: 'tutor', width: 20 },
          { header: 'PET', key: 'tutor', width: 20 },
          { header: 'Espécie', key: 'specie', width: 20 },
          { header: 'SERVIÇO', key: 'service', width: 20 },
          { header: 'Tam PET', key: 'petSize', width: 20 },
          { header: 'VALOR', key: 'value', width: 20 },
          { header: 'ADICIONAL', key: 'additional', width: 40 },
          { header: 'VALOR DO ADICIONAL', key: 'additionalValue', width: 30 },
          { header: 'DESCONTO', key: 'discount', width: 20 },
          { header: 'VALOR FINAL', key: 'finalValue', width: 20 },
          { header: 'VALOR 80%', key: 'value80', width: 20 },
          { header: 'STATUS PAGAMENTO', key: 'paymentStatus', width: 20 },
          { header: 'FORMA DE PAGAMENTO', key: 'paymentMethod', width: 30 },
          { header: 'CLASSIFICAÇÃO', key: 'classification', width: 20 },
          { header: '', key: 'empty', width: 20 },
          { header: 'NOME DO INSUMO', key: 'itemName', width: 30 },
          { header: 'VALOR DO INSUMO', key: 'itemName', width: 20 },
          { header: 'DATA DO INSUMO', key: 'itemName', width: 20 }
        ]

        worksheet.getRow(1).font = {
          size: 10,
          bold: true,
          color: { argb: 'FFFFFF' }
        }
        worksheet.getRow(1).alignment = {
          vertical: 'middle',
          horizontal: 'center'
        }

        worksheet.getCell('A1').fill = {
          type: 'pattern',
          fgColor: { argb: '518071' },
          pattern: 'solid'
        }
        worksheet.getCell('B1').fill = {
          type: 'pattern',
          fgColor: { argb: '518071' },
          pattern: 'solid'
        }
        worksheet.getCell('C1').fill = {
          type: 'pattern',
          fgColor: { argb: '518071' },
          pattern: 'solid'
        }
        worksheet.getCell('D1').fill = {
          type: 'pattern',
          fgColor: { argb: '518071' },
          pattern: 'solid'
        }
        worksheet.getCell('E1').fill = {
          type: 'pattern',
          fgColor: { argb: '518071' },
          pattern: 'solid'
        }
        worksheet.getCell('F1').fill = {
          type: 'pattern',
          fgColor: { argb: '518071' },
          pattern: 'solid'
        }
        worksheet.getCell('G1').fill = {
          type: 'pattern',
          fgColor: { argb: '518071' },
          pattern: 'solid'
        }
        worksheet.getCell('H1').fill = {
          type: 'pattern',
          fgColor: { argb: '518071' },
          pattern: 'solid'
        }
        worksheet.getCell('I1').fill = {
          type: 'pattern',
          fgColor: { argb: '518071' },
          pattern: 'solid'
        }
        worksheet.getCell('J1').fill = {
          type: 'pattern',
          fgColor: { argb: '518071' },
          pattern: 'solid'
        }
        worksheet.getCell('K1').fill = {
          type: 'pattern',
          fgColor: { argb: '518071' },
          pattern: 'solid'
        }
        worksheet.getCell('L1').fill = {
          type: 'pattern',
          fgColor: { argb: '518071' },
          pattern: 'solid'
        }
        worksheet.getCell('M1').fill = {
          type: 'pattern',
          fgColor: { argb: '518071' },
          pattern: 'solid'
        }
        worksheet.getCell('N1').fill = {
          type: 'pattern',
          fgColor: { argb: '518071' },
          pattern: 'solid'
        }
        worksheet.getCell('O1').fill = {
          type: 'pattern',
          fgColor: { argb: '518071' },
          pattern: 'solid'
        }

        worksheet.getCell('Q1').fill = {
          type: 'pattern',
          fgColor: { argb: '518071' },
          pattern: 'solid'
        }
        worksheet.getCell('R1').fill = {
          type: 'pattern',
          fgColor: { argb: '518071' },
          pattern: 'solid'
        }
        worksheet.getCell('S1').fill = {
          type: 'pattern',
          fgColor: { argb: '518071' },
          pattern: 'solid'
        }

        worksheet.getCell('A1').border = {
          top: { style: 'thin', color: { argb: '000000' } },
          left: { style: 'thin', color: { argb: '000000' } },
          bottom: { style: 'thin', color: { argb: '000000' } },
          right: { style: 'thin', color: { argb: '000000' } }
        }
        worksheet.getCell('B1').border = {
          top: { style: 'thin', color: { argb: '000000' } },
          left: { style: 'thin', color: { argb: '000000' } },
          bottom: { style: 'thin', color: { argb: '000000' } },
          right: { style: 'thin', color: { argb: '000000' } }
        }
        worksheet.getCell('C1').border = {
          top: { style: 'thin', color: { argb: '000000' } },
          left: { style: 'thin', color: { argb: '000000' } },
          bottom: { style: 'thin', color: { argb: '000000' } },
          right: { style: 'thin', color: { argb: '000000' } }
        }
        worksheet.getCell('D1').border = {
          top: { style: 'thin', color: { argb: '000000' } },
          left: { style: 'thin', color: { argb: '000000' } },
          bottom: { style: 'thin', color: { argb: '000000' } },
          right: { style: 'thin', color: { argb: '000000' } }
        }
        worksheet.getCell('E1').border = {
          top: { style: 'thin', color: { argb: '000000' } },
          left: { style: 'thin', color: { argb: '000000' } },
          bottom: { style: 'thin', color: { argb: '000000' } },
          right: { style: 'thin', color: { argb: '000000' } }
        }
        worksheet.getCell('F1').border = {
          top: { style: 'thin', color: { argb: '000000' } },
          left: { style: 'thin', color: { argb: '000000' } },
          bottom: { style: 'thin', color: { argb: '000000' } },
          right: { style: 'thin', color: { argb: '000000' } }
        }
        worksheet.getCell('G1').border = {
          top: { style: 'thin', color: { argb: '000000' } },
          left: { style: 'thin', color: { argb: '000000' } },
          bottom: { style: 'thin', color: { argb: '000000' } },
          right: { style: 'thin', color: { argb: '000000' } }
        }
        worksheet.getCell('H1').border = {
          top: { style: 'thin', color: { argb: '000000' } },
          left: { style: 'thin', color: { argb: '000000' } },
          bottom: { style: 'thin', color: { argb: '000000' } },
          right: { style: 'thin', color: { argb: '000000' } }
        }
        worksheet.getCell('I1').border = {
          top: { style: 'thin', color: { argb: '000000' } },
          left: { style: 'thin', color: { argb: '000000' } },
          bottom: { style: 'thin', color: { argb: '000000' } },
          right: { style: 'thin', color: { argb: '000000' } }
        }
        worksheet.getCell('J1').border = {
          top: { style: 'thin', color: { argb: '000000' } },
          left: { style: 'thin', color: { argb: '000000' } },
          bottom: { style: 'thin', color: { argb: '000000' } },
          right: { style: 'thin', color: { argb: '000000' } }
        }
        worksheet.getCell('K1').border = {
          top: { style: 'thin', color: { argb: '000000' } },
          left: { style: 'thin', color: { argb: '000000' } },
          bottom: { style: 'thin', color: { argb: '000000' } },
          right: { style: 'thin', color: { argb: '000000' } }
        }
        worksheet.getCell('L1').border = {
          top: { style: 'thin', color: { argb: '000000' } },
          left: { style: 'thin', color: { argb: '000000' } },
          bottom: { style: 'thin', color: { argb: '000000' } },
          right: { style: 'thin', color: { argb: '000000' } }
        }
        worksheet.getCell('M1').border = {
          top: { style: 'thin', color: { argb: '000000' } },
          left: { style: 'thin', color: { argb: '000000' } },
          bottom: { style: 'thin', color: { argb: '000000' } },
          right: { style: 'thin', color: { argb: '000000' } }
        }
        worksheet.getCell('N1').border = {
          top: { style: 'thin', color: { argb: '000000' } },
          left: { style: 'thin', color: { argb: '000000' } },
          bottom: { style: 'thin', color: { argb: '000000' } },
          right: { style: 'thin', color: { argb: '000000' } }
        }
        worksheet.getCell('O1').border = {
          top: { style: 'thin', color: { argb: '000000' } },
          left: { style: 'thin', color: { argb: '000000' } },
          bottom: { style: 'thin', color: { argb: '000000' } },
          right: { style: 'thin', color: { argb: '000000' } }
        }

        worksheet.getCell('Q1').border = {
          top: { style: 'thin', color: { argb: '000000' } },
          left: { style: 'thin', color: { argb: '000000' } },
          bottom: { style: 'thin', color: { argb: '000000' } },
          right: { style: 'thin', color: { argb: '000000' } }
        }
        worksheet.getCell('R1').border = {
          top: { style: 'thin', color: { argb: '000000' } },
          left: { style: 'thin', color: { argb: '000000' } },
          bottom: { style: 'thin', color: { argb: '000000' } },
          right: { style: 'thin', color: { argb: '000000' } }
        }
        worksheet.getCell('S1').border = {
          top: { style: 'thin', color: { argb: '000000' } },
          left: { style: 'thin', color: { argb: '000000' } },
          bottom: { style: 'thin', color: { argb: '000000' } },
          right: { style: 'thin', color: { argb: '000000' } }
        }

        const row = worksheet.getRow(1)
        row.height = 25

        // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
        //                                COLUMNS DATA
        // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

        csvData.forEach((line, lineIndex) => {
          worksheet.addRow([
            line.day,
            line.tutor,
            line.pet,
            line.specie,
            line.service,
            line.petSize,
            line.value,
            line.additional,
            line.additionalValue,
            line.discount,
            line.finalValue,
            line.value80,
            line.paymentStatus,
            line.paymentMethod,
            '',
            '',
            suppliesArray[lineIndex]?.item_name || undefined,
            suppliesArray[lineIndex]?.item_value
              ? `${convertToCurrencyFormat(
                  String(suppliesArray[lineIndex]?.item_value)
                )}`
              : undefined,
            suppliesArray[lineIndex]?.date
              ? format(
                  addDays(new Date(suppliesArray[lineIndex]?.date), 1),
                  "'Dia' dd 'de' LLL",
                  { locale: ptBR }
                )
              : undefined
          ])
        })

        worksheet.addRow([''])
        worksheet.addRow([''])
        worksheet.addRow(['Período:', time])
        worksheet.addRow(['Nome do Profissional:', professionalName])
        worksheet.addRow(['Total de Atendimentos:', totalRows])
        worksheet.addRow([
          'Faturamento Bruto:',
          `${convertToCurrencyFormat(String(revenue))}`
        ])
        worksheet.addRow([
          'Aluguel Mensal:',
          `${convertToCurrencyFormat(String(professionalRent))}`
        ])
        worksheet.addRow([
          'Total Insumos:',
          `${convertToCurrencyFormat(String(suppliesTotalValue))}`
        ])
        worksheet.addRow([
          'Comissão zazuu:',
          `${convertToCurrencyFormat(String(revenue * 0.2))}`
        ])

        // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
        //                                SUMMARY TABLE
        // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

        worksheet.getCell(`A${totalRows + 4}`).fill = {
          type: 'pattern',
          fgColor: { argb: '518071' },
          pattern: 'solid'
        }
        worksheet.getCell(`A${totalRows + 4}`).font = {
          size: 10,
          bold: true,
          color: { argb: 'FFFFFF' }
        }
        worksheet.getCell(`A${totalRows + 5}`).fill = {
          type: 'pattern',
          fgColor: { argb: '518071' },
          pattern: 'solid'
        }
        worksheet.getCell(`A${totalRows + 5}`).font = {
          size: 10,
          bold: true,
          color: { argb: 'FFFFFF' }
        }
        worksheet.getCell(`A${totalRows + 6}`).fill = {
          type: 'pattern',
          fgColor: { argb: '518071' },
          pattern: 'solid'
        }
        worksheet.getCell(`A${totalRows + 6}`).font = {
          size: 10,
          bold: true,
          color: { argb: 'FFFFFF' }
        }
        worksheet.getCell(`A${totalRows + 7}`).fill = {
          type: 'pattern',
          fgColor: { argb: '518071' },
          pattern: 'solid'
        }
        worksheet.getCell(`A${totalRows + 7}`).font = {
          size: 10,
          bold: true,
          color: { argb: 'FFFFFF' }
        }
        worksheet.getCell(`A${totalRows + 8}`).fill = {
          type: 'pattern',
          fgColor: { argb: '518071' },
          pattern: 'solid'
        }
        worksheet.getCell(`A${totalRows + 8}`).font = {
          size: 10,
          bold: true,
          color: { argb: 'FFFFFF' }
        }
        worksheet.getCell(`A${totalRows + 9}`).fill = {
          type: 'pattern',
          fgColor: { argb: '518071' },
          pattern: 'solid'
        }
        worksheet.getCell(`A${totalRows + 9}`).font = {
          size: 10,
          bold: true,
          color: { argb: 'FFFFFF' }
        }
        worksheet.getCell(`A${totalRows + 10}`).fill = {
          type: 'pattern',
          fgColor: { argb: '518071' },
          pattern: 'solid'
        }
        worksheet.getCell(`A${totalRows + 10}`).font = {
          size: 10,
          bold: true,
          color: { argb: 'FFFFFF' }
        }

        worksheet.getCell(`B${totalRows + 4}`).alignment = {
          vertical: 'middle',
          horizontal: 'right'
        }
        worksheet.getCell(`B${totalRows + 5}`).alignment = {
          vertical: 'middle',
          horizontal: 'right'
        }
        worksheet.getCell(`B${totalRows + 6}`).alignment = {
          vertical: 'middle',
          horizontal: 'right'
        }
        worksheet.getCell(`B${totalRows + 7}`).alignment = {
          vertical: 'middle',
          horizontal: 'right'
        }
        worksheet.getCell(`B${totalRows + 8}`).alignment = {
          vertical: 'middle',
          horizontal: 'right'
        }
        worksheet.getCell(`B${totalRows + 9}`).alignment = {
          vertical: 'middle',
          horizontal: 'right'
        }
        worksheet.getCell(`B${totalRows + 10}`).alignment = {
          vertical: 'middle',
          horizontal: 'right'
        }

        worksheet.getCell(`A${totalRows + 4}`).alignment = {
          vertical: 'middle',
          horizontal: 'left'
        }
        worksheet.getCell(`A${totalRows + 5}`).alignment = {
          vertical: 'middle',
          horizontal: 'left'
        }
        worksheet.getCell(`A${totalRows + 6}`).alignment = {
          vertical: 'middle',
          horizontal: 'left'
        }
        worksheet.getCell(`A${totalRows + 7}`).alignment = {
          vertical: 'middle',
          horizontal: 'left'
        }
        worksheet.getCell(`A${totalRows + 8}`).alignment = {
          vertical: 'middle',
          horizontal: 'left'
        }
        worksheet.getCell(`A${totalRows + 9}`).alignment = {
          vertical: 'middle',
          horizontal: 'left'
        }
        worksheet.getCell(`A${totalRows + 10}`).alignment = {
          vertical: 'middle',
          horizontal: 'left'
        }

        const heightCell1 = worksheet.getRow(totalRows + 4)
        const heightCell2 = worksheet.getRow(totalRows + 5)
        const heightCell3 = worksheet.getRow(totalRows + 6)
        const heightCell4 = worksheet.getRow(totalRows + 7)
        const heightCell5 = worksheet.getRow(totalRows + 8)
        const heightCell6 = worksheet.getRow(totalRows + 9)
        const heightCell7 = worksheet.getRow(totalRows + 10)
        heightCell1.height = 20
        heightCell2.height = 20
        heightCell3.height = 20
        heightCell4.height = 20
        heightCell5.height = 20
        heightCell6.height = 20
        heightCell7.height = 20

        worksheet.mergeCells(`B${totalRows + 4}:C${totalRows + 4}`)
        worksheet.mergeCells(`B${totalRows + 5}:C${totalRows + 5}`)
        worksheet.mergeCells(`B${totalRows + 6}:C${totalRows + 6}`)
        worksheet.mergeCells(`B${totalRows + 7}:C${totalRows + 7}`)
        worksheet.mergeCells(`B${totalRows + 8}:C${totalRows + 8}`)
        worksheet.mergeCells(`B${totalRows + 9}:C${totalRows + 9}`)
        worksheet.mergeCells(`B${totalRows + 10}:C${totalRows + 10}`)

        worksheet.getCell(`A${totalRows + 4}`).border = {
          top: { style: 'thin', color: { argb: '000000' } },
          left: { style: 'thin', color: { argb: '000000' } },
          bottom: { style: 'thin', color: { argb: '000000' } },
          right: { style: 'thin', color: { argb: '000000' } }
        }
        worksheet.getCell(`A${totalRows + 5}`).border = {
          top: { style: 'thin', color: { argb: '000000' } },
          left: { style: 'thin', color: { argb: '000000' } },
          bottom: { style: 'thin', color: { argb: '000000' } },
          right: { style: 'thin', color: { argb: '000000' } }
        }
        worksheet.getCell(`A${totalRows + 6}`).border = {
          top: { style: 'thin', color: { argb: '000000' } },
          left: { style: 'thin', color: { argb: '000000' } },
          bottom: { style: 'thin', color: { argb: '000000' } },
          right: { style: 'thin', color: { argb: '000000' } }
        }
        worksheet.getCell(`A${totalRows + 7}`).border = {
          top: { style: 'thin', color: { argb: '000000' } },
          left: { style: 'thin', color: { argb: '000000' } },
          bottom: { style: 'thin', color: { argb: '000000' } },
          right: { style: 'thin', color: { argb: '000000' } }
        }
        worksheet.getCell(`A${totalRows + 8}`).border = {
          top: { style: 'thin', color: { argb: '000000' } },
          left: { style: 'thin', color: { argb: '000000' } },
          bottom: { style: 'thin', color: { argb: '000000' } },
          right: { style: 'thin', color: { argb: '000000' } }
        }
        worksheet.getCell(`A${totalRows + 9}`).border = {
          top: { style: 'thin', color: { argb: '000000' } },
          left: { style: 'thin', color: { argb: '000000' } },
          bottom: { style: 'thin', color: { argb: '000000' } },
          right: { style: 'thin', color: { argb: '000000' } }
        }
        worksheet.getCell(`A${totalRows + 10}`).border = {
          top: { style: 'thin', color: { argb: '000000' } },
          left: { style: 'thin', color: { argb: '000000' } },
          bottom: { style: 'thin', color: { argb: '000000' } },
          right: { style: 'thin', color: { argb: '000000' } }
        }
        worksheet.getCell(`B${totalRows + 4}`).border = {
          top: { style: 'thin', color: { argb: '000000' } },
          left: { style: 'thin', color: { argb: '000000' } },
          bottom: { style: 'thin', color: { argb: '000000' } },
          right: { style: 'thin', color: { argb: '000000' } }
        }
        worksheet.getCell(`B${totalRows + 5}`).border = {
          top: { style: 'thin', color: { argb: '000000' } },
          left: { style: 'thin', color: { argb: '000000' } },
          bottom: { style: 'thin', color: { argb: '000000' } },
          right: { style: 'thin', color: { argb: '000000' } }
        }
        worksheet.getCell(`B${totalRows + 6}`).border = {
          top: { style: 'thin', color: { argb: '000000' } },
          left: { style: 'thin', color: { argb: '000000' } },
          bottom: { style: 'thin', color: { argb: '000000' } },
          right: { style: 'thin', color: { argb: '000000' } }
        }
        worksheet.getCell(`B${totalRows + 7}`).border = {
          top: { style: 'thin', color: { argb: '000000' } },
          left: { style: 'thin', color: { argb: '000000' } },
          bottom: { style: 'thin', color: { argb: '000000' } },
          right: { style: 'thin', color: { argb: '000000' } }
        }
        worksheet.getCell(`B${totalRows + 8}`).border = {
          top: { style: 'thin', color: { argb: '000000' } },
          left: { style: 'thin', color: { argb: '000000' } },
          bottom: { style: 'thin', color: { argb: '000000' } },
          right: { style: 'thin', color: { argb: '000000' } }
        }
        worksheet.getCell(`B${totalRows + 9}`).border = {
          top: { style: 'thin', color: { argb: '000000' } },
          left: { style: 'thin', color: { argb: '000000' } },
          bottom: { style: 'thin', color: { argb: '000000' } },
          right: { style: 'thin', color: { argb: '000000' } }
        }
        worksheet.getCell(`B${totalRows + 10}`).border = {
          top: { style: 'thin', color: { argb: '000000' } },
          left: { style: 'thin', color: { argb: '000000' } },
          bottom: { style: 'thin', color: { argb: '000000' } },
          right: { style: 'thin', color: { argb: '000000' } }
        }

        // worksheet.mergeCells(`D${totalRows + 5}:D${totalRows + 6}`);
        worksheet.mergeCells(`D${totalRows + 5}:D${totalRows + 7}`)

        const myBase64Image =
          'data:image/png;base64,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'
        const imageId2 = workbook.addImage({
          base64: myBase64Image,
          extension: 'png'
        })
        // worksheet.addImage(imageId2, `D${totalRows + 5}:D${totalRows + 6}`);
        worksheet.addImage(imageId2, `D${totalRows + 5}:D${totalRows + 7}`)

        // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
        //                                RENDER
        // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

        const writeFile = (newFileName: any, content: any) => {
          const link = document.createElement('a')

          const blob = new Blob([content], {
            type: 'application/vnd.ms-excel;charset=utf-8;'
          })

          link.download = `${fileName}.xlsx`
          link.href = URL.createObjectURL(blob)
          link.click()
        }

        const sheetName = `${fileName}.xlsx`

        workbook.xlsx.writeBuffer().then(buffer => {
          writeFile(sheetName, buffer)
        })
      } catch (error) {
        toast('Ocorreu um erro inesperado com a biblioteca.', {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          type: 'error'
        })
      }
    },
    []
  )

  const loadData = useCallback(async () => {
    try {
      setLoading(true)

      const results = await client.query({
        query: gql`
          query {
            professionals {
              id
              truck_rent
              user {
                name
                roles {
                  name
                }
              }
            }
          }
        `
      })

      setProfessionals(
        results.data.professionals.sort((a: any, b: any) => {
          if (a.user.name < b.user.name) {
            return -1
          }
          if (a.user.name > b.user.name) {
            return 1
          }
          return 0
        })
      )

      setLoading(false)
    } catch (error) {
      toast('Erro ao listar profissionais', {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        type: 'error'
      })
    }
  }, [])

  useEffect(() => {
    loadData()
  }, [loadData])

  const convertMsToDays = useCallback(ms => {
    const msInOneSecond = 1000
    const secondsInOneMinute = 60
    const minutesInOneHour = 60
    const hoursInOneDay = 24

    const minutesInOneDay = hoursInOneDay * minutesInOneHour
    const secondsInOneDay = secondsInOneMinute * minutesInOneDay
    const msInOneDay = msInOneSecond * secondsInOneDay

    return Math.ceil(ms / msInOneDay)
  }, [])

  const getDaysBetweenDates = useCallback(
    (dateOne, dateTwo) => {
      let differenceInMs = dateTwo.getTime() - dateOne.getTime()

      if (differenceInMs < 0) {
        differenceInMs = dateOne.getTime() - dateTwo.getTime()
      }

      return convertMsToDays(differenceInMs)
    },
    [convertMsToDays]
  )

  const handleSubmit = useCallback(
    async (data: IDataReports): Promise<void> => {
      try {
        setLoading(true)

        if (data.dateInitial === '') {
          toast('Escolha uma data inicial', {
            position: 'top-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            type: 'warning'
          })

          setLoading(false)

          return
        }

        if (data.dateFinal === '') {
          toast('Escolha uma data final', {
            position: 'top-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            type: 'warning'
          })

          setLoading(false)

          return
        }

        if (isBefore(new Date(data.dateFinal), new Date(data.dateInitial))) {
          toast('Data final anterior a data inicial não é permitido', {
            position: 'top-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            type: 'warning'
          })

          setLoading(false)

          return
        }

        if (
          getDaysBetweenDates(
            new Date(data.dateInitial),
            new Date(data.dateFinal)
          ) > 31
        ) {
          toast('Selecione datas de no máximo 1 mês de diferença', {
            position: 'top-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            type: 'warning'
          })

          setLoading(false)

          return
        }

        if (data.professionalId === '') {
          toast('Escolha um profissional para gerar o relatório', {
            position: 'top-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            type: 'warning'
          })

          setLoading(false)

          return
        }

        const appointments = await client.query({
          query: gql`
            query(
              $professionalId: String
              $dateFinal: String
              $dateInitial: String
            ) {
              appointmentsByProfessional(
                professionalId: $professionalId
                dateFinal: $dateFinal
                dateInitial: $dateInitial
              ) {
                appointments {
                  id
                  date
                  appointments_items {
                    item_price
                    item {
                      name
                    }
                  }
                  customer {
                    user {
                      name
                    }
                  }
                  pet {
                    name
                    specie {
                      name
                    }
                    weight
                  }
                  service {
                    name
                  }
                  service_price
                  order {
                    condominium_discount
                    coupon
                    discount_by_admin
                    increase_by_admin
                    status
                    platform
                    discount_by_admin
                    transactions {
                      type
                      amount
                    }
                  }
                }
              }
            }
          `,
          variables: {
            professionalId: data.professionalId.split('|')[0],
            dateInitial: data.dateInitial,
            dateFinal: data.dateFinal
          }
        })

        const excelData: IExcelDataProps[] = []

        let revenue = 0
        let totalSupplyValue = 0

        const results = await client.query({
          query: gql`
            query(
              $endDate: String!
              $startDate: String!
              $professionalId: String!
            ) {
              professionalsSupplies(
                end_date: $endDate
                start_date: $startDate
                professional_id: $professionalId
              ) {
                item_value
                item_name
                date
              }
            }
          `,
          variables: {
            startDate: data.dateInitial,
            endDate: data.dateFinal,
            professionalId: data.professionalId.split('|')[0]
          }
        })

        for (const supply of results.data.professionalsSupplies) {
          totalSupplyValue += Number(supply.item_value)
        }

        for (const day of appointments.data.appointmentsByProfessional) {
          for (const app of day.appointments) {
            let currentAdditionalPrice = 0
            let currentDiscountPrice = 0

            for (const item of app.appointments_items) {
              currentAdditionalPrice += Number(item.item_price)
            }

            const additionalArrayAsString = app.appointments_items.map(
              (add: any) => add.item.name
            )

            currentDiscountPrice =
              Number(app.order.condominium_discount) +
              Number(app.order.coupon) +
              Number(app.order.discount_by_admin) -
              Number(app.order.increase_by_admin)

            const price = (Number(app.service_price) / 100) * 0.88
            const discount = Number(currentDiscountPrice)
            const finalPrice =
              Number(app.service_price) / 100 + Number(currentAdditionalPrice)

            revenue += Number(finalPrice * 0.88)

            excelData.push({
              day:
                format(addDays(new Date(app.date), 1), "'Dia' dd 'de' LLL", {
                  locale: ptBR
                }) || 'Dia 00',
              tutor: app.customer.user.name,
              pet: app.pet.name,
              specie: app.pet.specie.name,
              service: app.service.name,
              petSize: calculateSizeByWeigthPet({
                specie: app.pet.specie.name,
                weight: app.pet.weight
              }),
              value: Number(price),
              additional: `${additionalArrayAsString}`,
              // additionalValue: Number(currentAdditionalPrice),
              additionalValue: Number(currentAdditionalPrice * 0.88),
              discount: Number(discount),
              // finalValue: Number(finalPrice),
              finalValue: Number(Number(finalPrice * 0.88).toFixed(2)),
              value80: Number(Number(finalPrice * 0.88 * 0.8).toFixed(2)),
              paymentStatus: app.order.status,
              paymentMethod: app?.order?.transactions[0]?.type
                ? TypePaymentEnum[app.order.transactions[0].type]
                : 'sem registro'
            })
          }
        }

        const time = `${format(
          addDays(new Date(data.dateInitial), 1),
          "'dia' dd 'de' LLL",
          { locale: ptBR }
        )} até ${format(
          addDays(new Date(data.dateFinal), 1),
          "'dia' dd 'de' LLL",
          { locale: ptBR }
        )}`
        const professionalName = data.professionalId.split('|')[1].split(' ')[0]
        const professionalRent = Number(data.professionalId.split('|')[2]) * 2
        const totalRows = excelData.length

        if (excelData.length === 0) {
          toast(
            'Relatório não gerado pois nenhum dado foi encontrado para essa combinação de datas e profissional.',
            {
              position: 'top-right',
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              type: 'warning'
            }
          )

          setLoading(false)

          return
        }

        exportToCSV(
          excelData,
          `Relatório financeiro de ${professionalName} - ${time}`,
          time,
          professionalName,
          totalRows,
          revenue,
          `${professionalRent}`,
          totalSupplyValue,
          results.data.professionalsSupplies
        )

        toast(`Relatório com ${excelData.length} linhas gerado com sucesso.`, {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          type: 'success'
        })

        setLoading(false)
      } catch (error) {
        setLoading(false)

        toast('Ocorreu um erro ao gerar relatório', {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          type: 'warning'
        })
      }
    },
    [exportToCSV, getDaysBetweenDates]
  )

  return (
    <Styles.Container>
      <Styles.Title>Relatório Financeiro</Styles.Title>

      <Form ref={formRef} onSubmit={handleSubmit}>
        <Styles.FiltersContainer>
          <Styles.Row>
            <Styles.CalendarOption>
              <p>Data inicial</p>

              <InputRef
                name="dateInitial"
                placeholder="data inicial"
                type="date"
              />
            </Styles.CalendarOption>

            <Styles.CalendarOption>
              <p>Data final</p>

              <InputRef name="dateFinal" placeholder="data final" type="date" />
            </Styles.CalendarOption>
          </Styles.Row>

          <Styles.ProfessionalOption>
            <p>Profissional</p>

            <SelectRef
              name="professionalId"
              placeholder="Nome do profissional"
              style={{ width: '100%' }}
              menuPortalTarget={document.getElementById('select-control')}
              menuPlacement="auto"
              options={Object.entries(professionals).map(pro => ({
                value: `${pro[1].id}|${pro[1].user.name}|${pro[1].truck_rent}`,
                label: pro[1].user.name
              }))}
            />
          </Styles.ProfessionalOption>
        </Styles.FiltersContainer>

        <Button
          behavior="primary"
          type="submit"
          text="Gerar"
          style={{ width: '100%' }}
          loading={loading}
        />
      </Form>
    </Styles.Container>
  )
}

export default FinancialReports
